import lang from "@/views/modules/Branchs/language/en";
//import Editor from '@tinymce/tinymce-vue';
export default {
    name: "edit-example",
    components: {
//        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            showDropdown: null,
            is_add_user: false,
            branchObj: {},
            multibranchObj: {
                record:'',
                branch_id:'',
                branch_name:'',
                user_id:'',
                user_name:'',
                username:'',
                users:[],
            },
            lang:[],
            user_error:'',
        }
    },
    mounted() {
        this.getData();
        this.getMultiBranchInfo();
        this.lang = lang;
    },
    methods: {
        getData() {
            const self = this;
            self.loading = true;
             window.currentAction = 'detail';
                axios.get('api/modules/branchs/' + self.$route.params.id).then(function (response) {
                self.branchObj = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        addUser(){
            this.user_error = '';
            // The displayed list is cross-branch, so a client-side duplicate check
            // would wrongly block a user who only exists in another branch. Let the
            // backend decide (it returns 'User already added' scoped to THIS branch).
            let user = {
                'branch_id': this.branchObj.id,
                'branch_name': this.branchObj.name,
                'user_id': this.multibranchObj.user_id,
                'user_name': this.multibranchObj.user_name,
                'username': this.multibranchObj.username,
            }
            this.multibranchObj.branch_id = this.branchObj.id;
            this.multibranchObj.branch_name = this.branchObj.name;
            this.SaveMultiBranch(user);
            this.multibranchObj.user_id = '';
            this.multibranchObj.user_name = '';
            this.multibranchObj.username = '';
        },
        removeUser(user_id, multibranch_id){
            //// remove the exact multibranchs row (list is cross-branch); backend
            //// deletes by multibranch_id and authorizes against that row's branch.
            const self = this;
            axios.get('api/modules/multibranchs/axioscall', {params:{'deleteUser':true, 'user_id':user_id, 'multibranch_id':multibranch_id, 'branch_id':self.$route.params.id}}).then(function (response) {
                self.getMultiBranchInfo();
                self.user_error = '';
            });
        },
        SaveMultiBranch(userinfo){
            const self = this;
            self.loading = true;
            let multiBranch = {
                users:userinfo,
                record:'',
                branch_id:this.branchObj.id,
                branch_name:this.branchObj.name
            }

            if(self.user_error == ''){
                window.currentAction = 'add';
                axios.post('api/modules/multibranchs', multiBranch).then(function (response) {
                    self.loading = false;
                    if(response.data.message != 'Data saved correctly'){
                        self.user_error = response.data.message;
                    }
                    self.getMultiBranchInfo();
                }).catch(function () {
                    self.loading = false;
                });
            }
        },
        getMultiBranchInfo(){
            const self = this;      
            axios.get('api/modules/multibranchs/axioscall', {params:{'getBranchInfo':true, 'branch_id':self.$route.params.id}}).then(function (response) {
                self.multibranchObj.users = response.data.items;
                self.user_error = '';
            });
            
        },
        openComponent(routeName, moduleName, field_id, queryData = null) {
            this.field_id = field_id;
            this.windowRef = window.open(`/popup?module=${routeName}&body=modal&callback=parentMethod&moduleName=${moduleName}`, "", "width=900,height=400,left=200,top=200");
            this.parentCompnent = routeName;
            this.windowRef.addEventListener('beforeunload', this.parentMethod);

        },
        parentMethod() {
            const module_name = this.parentCompnent.slice(0, -1);
            const parent_id = localStorage.getItem('parentid');
            const parent_name = localStorage.getItem('parentname');
            const parent_type = localStorage.getItem('parenttype');
            const parentObj = JSON.parse(localStorage.getItem('parentObj'));
            this.selectElement(module_name, parent_name, parent_id, parent_type);

            if (this.windowRef) {
                this.windowRef.close();
                this.windowRef = null;
                this.$emit('close');
            }

            if(parent_type == 'user'){
                this.multibranchObj.username = parentObj.user_name;
            }
                        
            localStorage.removeItem('parentid');
            localStorage.removeItem('parentname');
            localStorage.removeItem('parenttype');

        },
        updateItem(id, name, type, itemObj) {
            this.showDropdown = false;
            const module_name = type;
            if(module_name == 'user'){
                this.multibranchObj.username = itemObj.user_name;
            }
            this.selectElement(module_name, name, id, type);            
        },
        selectElement(moduleName, name = null, id = null, module = null, moduleObj) {

            const module_name = moduleName.replace("-", "_");
            const p_name = module_name + '_name';
            const p_name_el = document.getElementById(p_name);
           
            p_name_el.value = name;
            p_name_el.dispatchEvent(new Event('input'));
            const p_id = this.field_id;
            const p_id_el = document.getElementById(p_id);
            p_id_el.value = id;
            p_id_el.dispatchEvent(new Event('input'));
            //this.field_id = null;
           
            if(moduleName == 'branch'){
                this.getMultiBranchInfo(id);
            }

        },
        clearComponent(modulesLink) {
            const self = this;
            self.dropdownList = [];
            if (self.dropdownList.length == 0) {
                self.selectElement(modulesLink, '', '', '');
            }
        },
        queryForKeywords(e, modulesLink, field_id) {
            const self = this;
            self.field_id = field_id;
            let searchData = e.target.value;
            let relatedModule = modulesLink + 's';
            self.showDropdown = null;

            if (searchData.length > 0) {
                // On the branch subpanel, the user picker must list ALL active users
                // (any branch) so they can be added to this branch; the backend still
                // rejects a user already added to this branch.
                let payload = { 'data': searchData, 'relatedModule': relatedModule };
                if (relatedModule === 'users') {
                    payload.allUsers = true;
                }
                axios.post(`api/modules/searchItem`, payload).then(function (response) {
                    self.dropdownList = response.data;
                    self.showDropdown = field_id;
                });
            } else {
                self.showDropdown = false;
                self.dropdownList = [];

                if (searchData.length == 0) {
                    self.selectElement(modulesLink, '', '', '');
                }

            }
        },
    }
}